import { PanelBody } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

import LoopColumnsControls from "../../../_shared/loop-columns-controls";

export default function LayoutPanel({ displayLayout, updateLayout, isSlider }) {
  return (
    <PanelBody title={__("Layout", "brandy-blocks")}>
      <LoopColumnsControls
        displayLayout={displayLayout}
        updateLayout={updateLayout}
        isSlider={isSlider}
      />
      {/* Columns live here but the gap lives on the child, following Query Loop
          (core/post-template owns blockGap; core/query has no spacing support).
          Signposted rather than duplicated, so there is still one control. */}
      <p className="components-base-control__help">
        {__(
          "Spacing between posts comes from the Post Template block's Block spacing, as it does in the Query Loop.",
          "brandy-blocks"
        )}
      </p>
    </PanelBody>
  );
}
